import React from 'react';
import '../../../styles/MeepMeep.css';

interface MeepMeepBadgeProps {
  type?: 'payload' | 'microstructure' | 'parity-pass' | 'parity-fail';
  label?: string;
  className?: string;
}

export const MeepMeepBadge: React.FC<MeepMeepBadgeProps> = ({ 
  type = 'payload', 
  label, 
  className = '' 
}) => {
  const getBadgeContent = () => {
    switch (type) {
      case 'payload':
        return {
          text: label || 'Payload Aware',
          icon: (
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
              <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" />
              <polyline points="7.5 4.21 12 6.81 16.5 4.21" />
              <polyline points="7.5 19.79 7.5 14.63 12 12.03 16.5 14.63 16.5 19.79" />
              <polyline points="12 12.03 12 6.81" />
            </svg>
          ),
          styleClass: 'meep-badge-micro meep-glow-cyan'
        };
      case 'microstructure':
        return {
          text: label || 'Microstructure',
          icon: (
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="12" cy="12" r="3" />
              <path d="M12 2v2" />
              <path d="M12 20v2" />
              <path d="M4.93 4.93l1.41 1.41" />
              <path d="M17.66 17.66l1.41 1.41" />
              <path d="M2 12h2" />
              <path d="M20 12h2" />
              <path d="M6.34 17.66l-1.41 1.41" />
              <path d="M19.07 4.93l-1.41 1.41" />
            </svg>
          ),
          styleClass: 'meep-badge-micro meep-glow-amber'
        };
      case 'parity-pass':
        return {
          text: label || 'Parity Pass',
          icon: (
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
              <polyline points="20 6 9 17 4 12" />
            </svg>
          ),
          styleClass: 'meep-badge-micro meep-glow-emerald'
        };
      case 'parity-fail':
        return {
          text: label || 'Parity Blocked',
          icon: (
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="12" cy="12" r="10" />
              <line x1="15" y1="9" x2="9" y2="15" />
              <line x1="9" y1="9" x2="15" y2="15" />
            </svg>
          ),
          styleClass: 'meep-badge-micro meep-glow-amber'
        };
      default:
        return { text: label || 'Payload', icon: null, styleClass: 'meep-badge-micro' };
    }
  };

  const { text, icon, styleClass } = getBadgeContent();

  return (
    <div className={`${styleClass} ${className} user-select-none`}>
      {icon}
      <span>{text}</span>
    </div>
  );
};
